module.exports = __webpack_public_path__ + "img/8@3x.3550f592.png";